module.exports = __webpack_public_path__ + "static/img-ekupi-2f8d585315dc1ac8146217cdb1accb90.png";